import type { RefObject } from 'react';
import { useEffect } from 'react';

export const useOnClickOutside = <T extends HTMLElement>(
  ref: RefObject<T | null>,
  handler: (event: MouseEvent | TouchEvent) => void,
): void => {
  const isClient = typeof document === 'object';

  useEffect(() => {
    if (!isClient) {
      return;
    }

    const listener = (event: MouseEvent | TouchEvent) => {
      if (!ref.current || (event.target instanceof Node && ref.current.contains(event.target))) {
        return;
      }

      handler(event);
    };

    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);

    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, handler, isClient]);
};
